import { createSlice } from "@reduxjs/toolkit";

const fundsSlice = createSlice({
  name: "fundsReducer",
  initialState: {
    funds: {},
  },
  reducers: {
    setAvailableFunds: (state, action) => {
      const { payload } = action;
      state.funds = payload;
    },
  },
});

export const {
  actions: { setAvailableFunds },
  reducer: fundsReducer,
} = fundsSlice;
